import { i18nProvider } from "@trumpf/ux.i18n";

export const dynamicBulletsHandler = (bulletsContainer: HTMLDivElement): boolean => {
    const { t } = i18nProvider;
    const bullets = bulletsContainer.querySelectorAll("span");

    for (let i = 0; i < bullets.length; i++) {
        bullets[i].setAttribute("role", "button");
        bullets[i].setAttribute("aria-label", `${t("slider.paginationBullet.label")} ${i + 1}`);
    }
    if (bullets.length < 9) {
        return false;
    }
    const activeBulletEl = bulletsContainer.querySelector(".swiper-pagination-bullet-active");
    const activeIndex = [].indexOf.call(bullets, activeBulletEl);
    const invisible = "ux-slider-pagination__bullet--invisible";
    const small = "ux-slider-pagination__bullet--small";
    const xSmall = "ux-slider-pagination__bullet--extra-small";

    const handleClass = (condition: boolean, className: string, i: number, removeClass: string | null = null): void => {
        if (condition) {
            bullets[i].classList.add(className);
            if (removeClass !== null) {
                bullets[i].classList.remove(removeClass);
            }
        } else {
            bullets[i].classList.remove(className);
        }
    };

    for (let i = 0; i < bullets.length; i++) {
        if (activeIndex === 0) {
            handleClass(i === 7, small, i);
            handleClass(i === 8, xSmall, i);
            handleClass(i > 8, invisible, i);
        } else if (i < activeIndex) {
            if (activeIndex === bullets.length - 2) {
                handleClass(activeIndex === i + 6, small, i);
                handleClass(activeIndex === i + 7, xSmall, i);
                handleClass(activeIndex > i + 7, invisible, i);
            } else if (activeIndex === bullets.length - 1) {
                handleClass(activeIndex === i + 7, small, i);
                handleClass(activeIndex === i + 8, xSmall, i);
                handleClass(activeIndex > i + 8, invisible, i);
            } else {
                handleClass(activeIndex === i + 6, small, i);
                bullets[i].classList.remove(xSmall);
                handleClass(activeIndex > i + 6, invisible, i);
            }
        } else if (activeIndex < 6) {
            handleClass(i === 7, small, i);
            handleClass(i === 8, xSmall, i);
            handleClass(i > 8, invisible, i);
        } else if (activeIndex >= 6) {
            handleClass(i - 1 === activeIndex, small, i, invisible);
            handleClass(i - 2 === activeIndex, xSmall, i, invisible);
            handleClass(i - 2 > activeIndex, invisible, i, small);
        }
    }
    return true;
};
